"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointsFormatResult = void 0;
const data_type_1 = require("../../data/data-type");
const query_output_1 = require("./query-output");
/**
 * Data available as part of a Points Format query result.
 */
class PointsFormatResult extends query_output_1.QueryOutput {
}
exports.PointsFormatResult = PointsFormatResult;
/**
 * Pattern is stored in String format.
 */
PointsFormatResult.PATTERN = new PointsFormatResult('pattern', data_type_1.DataType.STRING);
//# sourceMappingURL=points-format-result.js.map